"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImTranslator = void 0;
class ImTranslator {
    constructor(locale, showLogs) {
        this.locale = locale;
        this.showLogs = showLogs;
        this.translations = {};
        this.loaders = {};
    }
    _translate(resource, key, interpolateParams, returnKeyIfNotFound = true) {
        return new Promise((resolve, reject) => {
            if (this.translations[resource]) {
                const res = this.getValue(returnKeyIfNotFound, resource, key, interpolateParams);
                resolve(res);
            }
            else {
                this.loadTranslations(resource)
                    .then(() => {
                    const res = this.getValue(returnKeyIfNotFound, resource, key, interpolateParams);
                    resolve(res);
                })
                    .catch(err => {
                    const res = this.getValue(returnKeyIfNotFound, resource, key, interpolateParams);
                    resolve(res);
                });
            }
        });
    }
    _translateInstant(resource, key, interpolateParams, returnKeyIfNotFound = true) {
        return this.getValue(returnKeyIfNotFound, resource, key, interpolateParams, true);
    }
    getValue(returnKeyIfNotFound, resource, key, interpolateParams, isInstantRequest = false) {
        const translations = this.translations[resource];
        let response;
        if (typeof key === 'string') {
            response = translations ? this.getSingleValue(returnKeyIfNotFound, translations, key, resource, isInstantRequest, interpolateParams) : this.getNotFoundResponse(returnKeyIfNotFound, key, resource, isInstantRequest);
        }
        else {
            response = {};
            key.forEach(k => {
                response[k] = translations ? this.getSingleValue(returnKeyIfNotFound, translations, k, resource, isInstantRequest, interpolateParams) : this.getNotFoundResponse(returnKeyIfNotFound, k, resource, isInstantRequest);
            });
        }
        return response;
    }
    getSingleValue(returnKeyIfNotFound, translations, key, resource, isInstantRequest, interpolateParams) {
        let response = translations[key] || undefined;
        if (response !== undefined) {
            if (interpolateParams) {
                response = this.interpolateString(response, interpolateParams);
            }
        }
        else {
            response = this.getNotFoundResponse(returnKeyIfNotFound, key, resource, isInstantRequest);
        }
        return response;
    }
    getNotFoundResponse(returnKeyIfNotFound, key, resource, isInstantRequest) {
        if (this.showLogs) {
            this.logMissingError(key, resource, isInstantRequest);
        }
        return returnKeyIfNotFound ? key : undefined;
    }
    interpolateString(expr, params) {
        for (const key in params) {
            expr = expr.replace(`{{${key}}}`, params[key]);
        }
        return expr;
    }
    logMissingError(key, resource, isInstantRequest) {
        if (isInstantRequest) {
            if (this.translations.hasOwnProperty(resource)) {
                console.warn(`Failed to instantly translate '${key}' key for ${this.locale} locale`);
            }
        }
        else {
            console.warn(`Failed to translate '${key}' key for ${this.locale} locale`);
        }
    }
}
exports.ImTranslator = ImTranslator;
